// extracted by mini-css-extract-plugin
export var banner = "_go-0";
export var closeButton = "_go-2";
export var greenCheckmark = "_go-3";
export var hereLink = "_go-4";
export var titleIcon = "_go-1";